import React from 'react';
import Lottie from 'lottie-react';
import aiLoaderBlack from '../assets/AI-loader-black.json';
import aiLoaderOrange from '../assets/AI-loader-orange.json';
import aiLoaderWhite from '../assets/AI-loader-white.json';

interface LoadingAnimationProps {
  color?: 'brand' | 'black' | 'white';
  size?: number;
}

export const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  color = 'brand',
  size = 20,
}) => {
  const animationData =
    color === 'brand' ? aiLoaderOrange : color === 'white' ? aiLoaderWhite : aiLoaderBlack;

  return <Lottie animationData={animationData} loop style={{ height: size }} />;
};
